// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: whitesmoke;
    
}
.search-button {
    background-color: #286090;
    color: white;
    height: 35px;
    padding: 3px 15px;
    border-radius: 5px;
    cursor: pointer;
  }

.scroll{
    color:red;
    font-size: 18px;
    font-weight: 30px;
}
.doa-container {
    border: 1px solid #0b2d71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}
.header{
    background-color: #286090;
    text-align: left;
    margin-left:20px;
    margin-right: 20px;
    height:35px;
    
}
.header1{
    padding-top: 5px;
    padding-left: 10px;
    color:black;
}
.catTitle{
    color: #286090;
    margin-left:30px;
    
}
.boldtext{
    font-weight: bold;
    padding-left:70px;
    color:black;
    margin-top:15px;
    padding-bottom: 15px;
}
 
.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width:100%;
}

.doa-container1 {
    border: 2px solid #0b2d71;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
}

.one{
    font-size: 20px;
    
}

.doatypename{
    float:left;
    margin-left:50px;
}

.employeedetails{
    float:right;
    margin-right:200px;
} 

.container2{
    background-color: #F1F1F1;
    border:solid 1px #d4d4d4;
    border-radius:5px;
    margin-bottom:15px;
    padding:50px;
}
.scroll{
    color:red;
    font-size: 18px;
    font-weight: 30px;
}
.doa-container {
    border: 1px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}
.header{
    background-color:#5385b0 ;
    text-align: left;
    margin-left:20px;
    margin-right: 20px;
    height:35px;
    
}
.header1{
    padding-top: 5px;
    padding-left: 10px;
    color:black;
}
.catTitle{
    color: rgba(0, 48, 153, 1);
    margin-left:30px;
    font-family:"GothamNarrowBook",Arial,sans-serif ;
}
.boldtext{
    font-weight: bold;
    padding-left:70px;
    color:black;
    margin-top:15px;
    padding-bottom: 15px;
}
 
.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width:100%;
}
.doatype {
    color: black;
    padding-left: 20%;
      
}
.doatype2 {    
    color: black;
    padding-left:55%;    
} 
.one{
    font-size: 20px;
    
}
.container1{
    height:30px;
    width:100%;
    background-color:#5385b0 ;
}

.doatypename{
margin-left:50px;
font-family:"GothamNarrowBook",Arial,sans-serif ;
}

.employeedetails{
    float:right;
    margin-right:200px;
}

.radio-label {
    margin-right: 15px;
    margin-left:5px;
  }
  .emailinput{
    margin-left:117px;
    height: 35px;
    border-radius:5px;
    width:230px;
  }
  .dateinput{
    margin-left:100px;
    height: 35px;
    border-radius:5px;
    width:150px;
  }
   .menu{
    background-color:#5385b0; 
  }
  .option{
    background-color: white;
    color: #000;
    font-weight: bolder;
  } 

  .viewAction{
    float: left;
    margin-right:300px;
  }
    /* Modal styles */
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  
  /* OK button styles */
  #closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  
  #closeSuccessModal:hover {
    background-color: #0056b3;
  }
  mat-spinner {
    margin: auto;
    position: absolute; 
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
  }
  
.title{
    font-family: "GothamBold",Arial,sans-serif;
}

.content{
    font-family:"GothamNarrowBook",Arial,sans-serif ;
}
:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
  }
  .actions {
    display: flex;
    justify-content: center;
  }
  
  .actions button {
    margin-right: 50px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
.form-control-sm.menu:disabled {
    color: #000; 
  }
   
  select:disabled {
    color: #000; 
    border-color: rgba(118, 118, 118, 0.3);
  }
`, "",{"version":3,"sources":["webpack://./src/app/doa/permanent-doa/permanentdoa.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;;AAEhC;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;AAEF;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;;AAEpB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gDAAgD;AACpD;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;;AAErB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;;AAEnB;AACA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;AAC7B;;AAEA;AACA,gBAAgB;AAChB,gDAAgD;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;GACC;IACC,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;IACE,iBAAiB;AACrB;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;EAC9E;;;EAGA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;AAEF;IACI,0CAA0C;AAC9C;;AAEA;IACI,gDAAgD;AACpD;AACA;IACI,wEAAwE;EAC1E;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;IACI,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sCAAsC;EACxC","sourcesContent":["body {\n    background-color: whitesmoke;\n    \n}\n.search-button {\n    background-color: #286090;\n    color: white;\n    height: 35px;\n    padding: 3px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.scroll{\n    color:red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n.doa-container {\n    border: 1px solid #0b2d71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.header{\n    background-color: #286090;\n    text-align: left;\n    margin-left:20px;\n    margin-right: 20px;\n    height:35px;\n    \n}\n.header1{\n    padding-top: 5px;\n    padding-left: 10px;\n    color:black;\n}\n.catTitle{\n    color: #286090;\n    margin-left:30px;\n    \n}\n.boldtext{\n    font-weight: bold;\n    padding-left:70px;\n    color:black;\n    margin-top:15px;\n    padding-bottom: 15px;\n}\n \n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width:100%;\n}\n\n.doa-container1 {\n    border: 2px solid #0b2d71;\n    width: 100%;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.one{\n    font-size: 20px;\n    \n}\n\n.doatypename{\n    float:left;\n    margin-left:50px;\n}\n\n.employeedetails{\n    float:right;\n    margin-right:200px;\n} \n\n.container2{\n    background-color: #F1F1F1;\n    border:solid 1px #d4d4d4;\n    border-radius:5px;\n    margin-bottom:15px;\n    padding:50px;\n}\n.scroll{\n    color:red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n.doa-container {\n    border: 1px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.header{\n    background-color:#5385b0 ;\n    text-align: left;\n    margin-left:20px;\n    margin-right: 20px;\n    height:35px;\n    \n}\n.header1{\n    padding-top: 5px;\n    padding-left: 10px;\n    color:black;\n}\n.catTitle{\n    color: rgba(0, 48, 153, 1);\n    margin-left:30px;\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n.boldtext{\n    font-weight: bold;\n    padding-left:70px;\n    color:black;\n    margin-top:15px;\n    padding-bottom: 15px;\n}\n \n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width:100%;\n}\n.doatype {\n    color: black;\n    padding-left: 20%;\n      \n}\n.doatype2 {    \n    color: black;\n    padding-left:55%;    \n} \n.one{\n    font-size: 20px;\n    \n}\n.container1{\n    height:30px;\n    width:100%;\n    background-color:#5385b0 ;\n}\n\n.doatypename{\nmargin-left:50px;\nfont-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n\n.employeedetails{\n    float:right;\n    margin-right:200px;\n}\n\n.radio-label {\n    margin-right: 15px;\n    margin-left:5px;\n  }\n  .emailinput{\n    margin-left:117px;\n    height: 35px;\n    border-radius:5px;\n    width:230px;\n  }\n  .dateinput{\n    margin-left:100px;\n    height: 35px;\n    border-radius:5px;\n    width:150px;\n  }\n   .menu{\n    background-color:#5385b0; \n  }\n  .option{\n    background-color: white;\n    color: #000;\n    font-weight: bolder;\n  } \n\n  .viewAction{\n    float: left;\n    margin-right:300px;\n  }\n    /* Modal styles */\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n  }\n  \n  .modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 500px;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  }\n  \n  \n  /* OK button styles */\n  #closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n  }\n  \n  #closeSuccessModal:hover {\n    background-color: #0056b3;\n  }\n  mat-spinner {\n    margin: auto;\n    position: absolute; \n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%); \n  }\n  \n.title{\n    font-family: \"GothamBold\",Arial,sans-serif;\n}\n\n.content{\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n  }\n  .actions {\n    display: flex;\n    justify-content: center;\n  }\n  \n  .actions button {\n    margin-right: 50px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n.form-control-sm.menu:disabled {\n    color: #000; \n  }\n   \n  select:disabled {\n    color: #000; \n    border-color: rgba(118, 118, 118, 0.3);\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
